module.exports = __webpack_public_path__ + "img/streaming-device-icon.e2b58024.svg";